import { Heading, HighlightedIcon, type IconComponent, Text } from '@backend/lib-design-system';
import { AwardFilledIcon, WorkFilledIcon } from '@backend/lib-design-system/icons';
import type { FC } from 'react';
import { styled } from 'styled-components';

interface FlexIconTextSubProps {
  iconName: 'award-filled' | 'work-filled';
  iconColor: 'purple' | 'blue';
  title: string;
  subtitle: string;
}

const iconMap: Record<FlexIconTextSubProps['iconName'], IconComponent> = {
  'award-filled': AwardFilledIcon,
  'work-filled': WorkFilledIcon,
};

const IWrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

const Subtitle = styled(Text)`
  color: ${({ theme }) => theme.colors.info?.normal};
`;

const TextWrapper = styled.div``;

export const FlexIconTextSub: FC<FlexIconTextSubProps> = ({ iconName, iconColor, title, subtitle }) => (
  <IWrapper>
    <HighlightedIcon icon={iconMap[iconName]} color={iconColor} />
    <TextWrapper>
      <Heading variant="heading-5" as="h3">
        {title}
      </Heading>
      <Subtitle variant="body-lighter">{subtitle}</Subtitle>
    </TextWrapper>
  </IWrapper>
);
